// Shows the optional SSN step once, on the first Dashboard visit after a
// new signup verifies. The patient isn't signed in at verify time, and the
// SSN endpoint needs a signed-in account (never an unverified one), so the
// step waits until after sign-in. Same localStorage pattern as
// claimGuidance.ts, scoped by email.
//
// Holds ONLY the email. Nothing SSN-related ever goes into browser storage.
const PENDING_SSN_PROMPT_KEY = "medsynciq_pending_ssn_prompt";

export function savePendingSsnPrompt(email: string) {
  localStorage.setItem(PENDING_SSN_PROMPT_KEY, email);
}

export function hasPendingSsnPrompt(email: string): boolean {
  return localStorage.getItem(PENDING_SSN_PROMPT_KEY) === email;
}

export function clearPendingSsnPrompt() {
  localStorage.removeItem(PENDING_SSN_PROMPT_KEY);
}
